// extracted by css-extract-rspack-plugin
export default {"defaultRoleText":"jGPQPzSjofwz44Bw","defaultRoleTextLabel":"Lulk4ce46jkGTN9J"};